import { userExist } from '@/api/user'
import { existPermission } from '@/api/permission'
import { existRole } from '@/api/role'
import { existPosition } from '@/api/position'
import { existDepartment } from '@/api/department'

export function checkPermission(rule, value, cb) {
    var param = {code: value}
    existPermission(param).then(response => {
        if(response.code===200){
            return cb()
        }
        if(response.code===10501){
            return cb(new Error('权限已存在'))
        }
        return cb()
    })
}

export function checkRole(rule, value, cb) {
    var param = {code: value}
    existRole(param).then(response => {
        if(response.code===200){
            return cb()
        }
        if(response.code===10401){
            return cb(new Error('角色已存在'))
        }
        return cb()
    })
}

export function checkPosition(rule, value, cb) {
    var param = {code: value}
    existPosition(param).then(response => {
        if(response.code===200){
            return cb()
        }
        if(response.code===10601){
            return cb(new Error('职务已存在'))
        }
        return cb()
    })
}
export function checkDepartment(rule, value, cb) {
    var param = {code: value}
    existDepartment(param).then(response => {
        if(response.code===200){
            return cb()
        }
        if(response.code===10301){
            return cb(new Error('部门已存在'))
        }
        return cb()
    })
}
/**
 * 手机号验证规则(包含是否手机号已存在)
 * @param rule
 * @param value
 * @param cb
 * @returns {*}
 */
export function checkMobile(rule, value, cb){
    // const regMobile = /^(0|86|17951)?(13[0-9]|15[0-9]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    const regMobile = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
    if (regMobile.test(value)) {
        var param = {mobile: value}
        userExist(param).then(response => {
            if(response.code===200){
                return cb(new Error('手机号已存在'))
            }
            if(response.code===4104){
                return cb()
            }
            return cb()
        })
    }else {
        return cb(new Error('请输入合法的手机号'))
    }
}
/**
 * 登录时手机号验证
 * @param rule
 * @param value
 * @param cb
 * @returns {*}
 */
export function checkMobileUse(rule, value, cb){
    const regMobile = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
    if (regMobile.test(value)) {
        var param = {mobile: value}
        userExist(param).then(response => {
            if(response.code===200){
                return cb()
            }
            if(response.code===4104){
                return cb(new Error('不存在该手机号'))
            }
            return cb(new Error('不存在该手机号'))
        })
    }else {
        return cb(new Error('请输入合法的手机号'))
    }
}
/**
 * 纯手机号验证
 * @param rule
 * @param value
 * @param cb
 * @returns {*}
 */
export function checkMobileOnly(rule, value, cb){
    const regMobile = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
    if (regMobile.test(value)) {
        return cb()
    }else {
        return cb(new Error('请输入合法的手机号'))
    }
}
/**
 * 密码是否一致验证规则
 * @param rule
 * @param value
 * @param cb
 * @returns {*}
 */
export function samePwd(rule, value, cb) {
    if(this.updatePwdForm.newPwd === this.updatePwdForm.againPwd){
        return cb()
    }
    return cb(new Error('新密码2次输入要一致'))
}

/**
 * 密码验证规则
 * @param rule
 * @param value
 * @param cb
 * @returns {*}
 */
export function isPassword(rule, value, cb) {
    // const reg =/^[_a-zA-Z0-9]+$/
    const reg =/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/
    if(value==''||value==undefined||value==null){
        return cb()
    } else {
        if (!reg.test(value)){
            cb(new Error('请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'))
        } else {
            return cb()
        }
    }
}

/**
 * 身份证号验证规则
 * @param rule
 * @param value
 * @param callback
 */
export function validateIdNo(rule, value,callback) {
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if(value==''||value==undefined||value==null){
        callback()
    }else {
        if ((!reg.test(value)) && value != '') {
            callback(new Error('请输入正确的身份证号码'))
        } else {
            callback()
        }
    }
}

/**
 * 邮箱验证规则
 * @param rule
 * @param value
 * @param callback
 */
export function validateEMail(rule, value,callback) {
    const reg =/^([a-zA-Z0-9]+[-_.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
    // const mal = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
    // const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    if(value==''||value==undefined||value==null){
        callback();
    }else{
        if (!reg.test(value)){
            callback(new Error('请输入正确的邮箱'))
        } else {
            callback();
        }
    }
}

/**
 * 中文校验
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export const validateContacts = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请输入中文'))
    }
    if (!/^[\u0391-\uFFE5A-Za-z]+$/.test(value)) {
        callback(new Error('不可输入特殊字符'))
    } else {
        callback()
    }
}
/**
 * 账号验证
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export const validateCode = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请输入账号'))
    }
    /*^(?![0-9]*$)|(?![a-zA-Z]*$)|[a-zA-Z0-9]{3,20}$*/
    if (!/^[a-zA-Z0-9_-]{3,20}$/.test(value)) {
        callback(new Error('账号必须为3-20位字母数字_组合'))
    } else {
        callback()
    }
}
/**
 * 纯数字验证
 * @param rule
 * @param value
 * @param callback
 */
export const validateNumber = (rule, value, callback) => {
    let numberReg = /^\d+$|^\d+[.]?\d+$/
    if (value !== '') {
        if (!numberReg.test(value)) {
            callback(new Error('请输入数值'))
        } else {
            callback()
        }
    } else {
        callback()
    }
}


